import SitePage from "@/components/application/site-page";
import { ReactNode } from "react";

function PrivacyPage() {
  return (
    <>
      <h1>Política de Privacidad</h1>
      <p>
        <strong>Última actualización:</strong> 26 de julio de 2026
      </p>

      <p>
        Esta Política de Privacidad explica cómo{" "}
        <strong>Gatito Pirata Technologies EIRL</strong> recolecta, usa y
        protege los datos personales procesados a través de BrickGestor, de
        acuerdo con la Ley N.° 29733, Ley de Protección de Datos Personales,
        su reglamento aprobado por Decreto Supremo N.° 003-2013-JUS, y,
        cuando corresponda, otros estándares internacionales relevantes de
        protección de datos.
      </p>

      <h2>1. Responsable del tratamiento</h2>
      <p>
        La entidad responsable del tratamiento de tus datos personales (el
        "responsable del tratamiento") es:
      </p>
      <p>
        <strong>Gatito Pirata Technologies EIRL</strong>
        <br />
        RUC: 20616175221
        <br />
        Perú
        <br />
        Correo: brickgestor@gatitopirata.com
      </p>

      <h2>2. Datos personales que recolectamos</h2>
      <p>Dependiendo de cómo uses BrickGestor, podemos recolectar:</p>
      <ul>
        <li>
          Datos de cuenta y contacto, como tu nombre y correo electrónico
        </li>
        <li>
          Datos de tienda que proporcionas, como el nombre de tu tienda,
          inventario, precios y descripciones
        </li>
        <li>Datos de facturación asociados a tu plan de suscripción</li>
        <li>
          Datos técnicos y de uso, como tipo de navegador, dirección IP,
          marcas de tiempo y páginas visitadas
        </li>
      </ul>
      <p>
        Solo recolectamos los datos personales razonablemente necesarios
        para brindar el servicio. Si nuevas funciones requieren datos
        adicionales en el futuro, te informaremos y los solicitaremos de
        acuerdo con esta Política.
      </p>

      <h2>3. Finalidad y base legal del tratamiento</h2>
      <p>Procesamos tus datos personales para:</p>
      <ul>
        <li>Crear y gestionar tu cuenta y tu(s) tienda(s)</li>
        <li>Brindar, mantener y mejorar el servicio BrickGestor</li>
        <li>Procesar la facturación y pagos de suscripción</li>
        <li>Comunicarnos contigo sobre tu cuenta o el servicio</li>
        <li>
          Mantener la seguridad de la plataforma y prevenir fraude o abuso
        </li>
        <li>Cumplir con obligaciones legales</li>
      </ul>
      <p>
        De acuerdo con el artículo 5 de la Ley N.° 29733, procesamos tus
        datos personales con base en tu consentimiento libre, previo,
        informado, expreso e inequívoco, otorgado al crear una cuenta o al
        usar BrickGestor de otra manera, salvo cuando la ley permita el
        tratamiento sin consentimiento (por ejemplo, para cumplir con una
        obligación legal).
      </p>

      <h2>4. Tus derechos (derechos ARCO)</h2>
      <p>
        Como titular de datos bajo la Ley N.° 29733, tienes derecho a:
      </p>
      <ul>
        <li>
          <strong>Acceder</strong> a los datos personales que tenemos sobre
          ti
        </li>
        <li>
          <strong>Rectificar</strong> datos inexactos o incompletos
        </li>
        <li>
          <strong>Cancelar</strong> (eliminar) tus datos cuando ya no sean
          necesarios o retires tu consentimiento
        </li>
        <li>
          <strong>Oponerte</strong> al tratamiento de tus datos por un
          motivo legítimo
        </li>
      </ul>
      <p>
        Estos son conocidos como tus derechos ARCO. Puedes ejercer
        cualquiera de ellos en cualquier momento escribiendo a{" "}
        <a href="mailto:brickgestor@gatitopirata.com">
          brickgestor@gatitopirata.com
        </a>
        . Responderemos dentro de los plazos establecidos por la ley.
      </p>
      <p>
        Si consideras que tus derechos no han sido respetados, puedes
        presentar una reclamación ante la Autoridad Nacional de Protección
        de Datos Personales, la autoridad peruana responsable del Registro
        Nacional de Protección de Datos Personales (RNPDP).
      </p>

      <h2>5. Transferencias internacionales de datos</h2>
      <p>
        Algunos de los proveedores de servicios que usamos para operar
        BrickGestor (como proveedores de hosting, correo electrónico y
        procesamiento de pagos) pueden estar ubicados fuera de Perú. Cuando
        transferimos datos personales internacionalmente, lo hacemos solo a
        destinatarios que mantengan un nivel adecuado de protección o bajo
        garantías contractuales equivalentes a las requeridas por el
        artículo 15 de la Ley N.° 29733 y su reglamento, y, cuando
        corresponda, en línea con otros estándares internacionales
        aplicables de protección de datos.
      </p>

      <h2>6. Retención de datos</h2>
      <p>
        Conservamos tus datos personales mientras tu cuenta esté activa o
        según sea necesario para brindar el servicio. Cuando elimines tu
        cuenta o solicites la cancelación de tus datos, los eliminaremos o
        anonimizaremos dentro de un plazo razonable, salvo que estemos
        legalmente obligados a conservarlos por más tiempo (por ejemplo,
        obligaciones tributarias o contables).
      </p>

      <h2>7. Medidas de seguridad</h2>
      <p>
        Implementamos medidas de seguridad técnicas, organizativas y
        legales para proteger tus datos personales contra pérdida, uso
        indebido, acceso no autorizado y alteración, según lo requerido por
        la Ley N.° 29733 y su reglamento. Sin embargo, ningún método de
        transmisión por Internet o almacenamiento electrónico es
        completamente seguro, y no podemos garantizar seguridad absoluta.
      </p>

      <h2>8. Cookies</h2>
      <p>
        BrickGestor usa cookies cuando es necesario para mantener tu sesión
        iniciada y recordar tus preferencias. No usamos cookies para
        publicidad de terceros.
      </p>

      <h2>9. Menores de edad</h2>
      <p>
        BrickGestor está destinado a usuarios de al menos 18 años, según se
        describe en nuestros Términos y Condiciones. No recolectamos
        conscientemente datos personales de menores.
      </p>

      <h2>10. Cambios a esta Política</h2>
      <p>
        Podemos actualizar esta Política de Privacidad de vez en cuando
        para reflejar cambios en nuestras prácticas o en la ley aplicable.
        Cuando lo hagamos, actualizaremos la fecha en la parte superior de
        esta página.
      </p>

      <h2>11. Contacto</h2>
      <p>
        Si tienes preguntas, solicitudes o sugerencias sobre esta Política
        de Privacidad o el tratamiento de tus datos personales, contáctanos
        en{" "}
        <a href="mailto:brickgestor@gatitopirata.com">
          brickgestor@gatitopirata.com
        </a>
        .
      </p>
    </>
  );
}
PrivacyPage.layout = (page: ReactNode) => <SitePage children={page} />;

export default PrivacyPage;
